const showAlertMessage = (type: string, title: string, message: string): void => {
    const alertMessage = JSON.stringify({ type, title, message });

    window.RahmetApp && window.RahmetApp.showNativeNotification
    && window.RahmetApp.showNativeNotification(alertMessage);
};

export default showAlertMessage;
